import { Injectable, Type } from '@angular/core';
import { KeyValue } from '@angular/common';

import { SpecificationHelperService } from './specification-helper.service';

import { ControlSpecification } from '../types/specification.types';

@Injectable({
  providedIn: 'root'
})
export class DesignerConfigurationService {
  controlSpecifications: Array<ControlSpecification> = [];

  propertyEditors: Array<KeyValue<string, Type<any>>> = [];

  constructor(specificationHelperService: SpecificationHelperService) {
    this.controlSpecifications = specificationHelperService.getControlSpecifications();
    this.propertyEditors = specificationHelperService.getPropertyEditors();
  }

  findControlSpecification(type: string): ControlSpecification {
    const list = this.controlSpecifications.filter((item: ControlSpecification) => item.name === type);
    return list.length === 0 ? undefined : list[0];
  }

  findControlComponent(type: string): Type<any> {
    const specification = this.findControlSpecification(type);
    return specification ? specification.component : undefined;
  }

  findPropertyEditorComponent(type: string): Type<any> {
    if (type === undefined) {
      return null;
    }
    const list = this.propertyEditors.filter((item: KeyValue<string, Type<any>>) => item.key === type);
    return list.length === 0 ? undefined : list[0].value;
  }
}
